// extracted by mini-css-extract-plugin
export default {"toolbarTab":"ToolbarTabs_toolbarTab__VMkFI","toolbarTabsList":"ToolbarTabs_toolbarTabsList__D-aJn"};